// extracted by mini-css-extract-plugin
export default {"search-button":"SearchButton_search-button__IVkK1","search-button-icon":"SearchButton_search-button-icon__idosY"};